if (!customElements.get('featured-blog-pagination')) {
  customElements.define('featured-blog-pagination', class FeaturedBlogPagination extends HTMLElement {
    constructor() {
      super();
      this.currentPage = 1;
      this._boundOnPrev = this.onPrev.bind(this);
      this._boundOnNext = this.onNext.bind(this);
    }

    connectedCallback() {
      this.totalPages = parseInt(this.getAttribute('data-total-pages'), 10) || 1;

      // Defer to ensure children are parsed
      if (window.requestAnimationFrame) {
        requestAnimationFrame(() => this.init());
      } else {
        setTimeout(() => this.init(), 0);
      }
    }

    init() {
      this.pagesContainer = this.querySelector('[data-pages]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');

      if (!this.pagesContainer || !this.prevBtn || !this.nextBtn) return;

      this.renderPages();
      this.updateArrowState();

      this.prevBtn.addEventListener('click', this._boundOnPrev);
      this.nextBtn.addEventListener('click', this._boundOnNext);
    }

    disconnectedCallback() {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this._boundOnPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this._boundOnNext);
    }

    onPrev() {
      if (this.currentPage > 1) {
        this.goToPage(this.currentPage - 1);
      }
    }

    onNext() {
      if (this.currentPage < this.totalPages) {
        this.goToPage(this.currentPage + 1);
      }
    }

    goToPage(page) {
      this.currentPage = page;
      const pages = this.querySelectorAll('[data-page]');
      pages.forEach((el) => {
        el.hidden = parseInt(el.dataset.page, 10) !== page;
      });
      this.renderPages();
      this.updateArrowState();
    }

    updateArrowState() {
      if (this.prevBtn) this.prevBtn.disabled = this.currentPage <= 1;
      if (this.nextBtn) this.nextBtn.disabled = this.currentPage >= this.totalPages;
    }

    getPageNumbers() {
      const total = this.totalPages;
      const current = this.currentPage;
      const siblings = 2;

      if (total <= 7) {
        const pages = [];
        for (let i = 1; i <= total; i++) pages.push(i);
        return pages;
      }

      const pages = [];
      const leftSibling = Math.max(current - siblings, 1);
      const rightSibling = Math.min(current + siblings, total);

      const showLeftEllipsis = leftSibling > 2;
      const showRightEllipsis = rightSibling < total - 1;

      pages.push(1);

      if (showLeftEllipsis) {
        pages.push('...');
      }

      for (let i = leftSibling; i <= rightSibling; i++) {
        if (i !== 1 && i !== total) {
          pages.push(i);
        }
      }

      if (showRightEllipsis) {
        pages.push('...');
      }

      if (total > 1) {
        pages.push(total);
      }

      return pages;
    }

    renderPages() {
      if (!this.pagesContainer) return;

      const pageNumbers = this.getPageNumbers();
      this.pagesContainer.innerHTML = '';

      pageNumbers.forEach((pageNum) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = String(pageNum);

        if (pageNum === '...') {
          btn.className = 'featured-blog__paginator-btn featured-blog__paginator-btn--ellipsis';
          btn.disabled = true;
          btn.setAttribute('aria-hidden', 'true');
        } else {
          btn.className = 'featured-blog__paginator-btn';
          btn.setAttribute('aria-label', 'Page ' + pageNum);
          if (pageNum === this.currentPage) {
            btn.classList.add('featured-blog__paginator-btn--active');
            btn.setAttribute('aria-current', 'page');
          }
          btn.addEventListener('click', () => this.goToPage(pageNum));
        }

        this.pagesContainer.appendChild(btn);
      });
    }
  });
}
